<template>
    <button @click="reloadPage" class="room__control room__refresh r-button" title="Обновите страницу, если возникли проблемы со связью" type="button">
        <span class="room__control-text" >Обновить страницу</span>
    </button>
</template>

<script>
    export default {
        name: "Refresh",
        methods: {
            reloadPage() {
                return window.location.reload();
            }
        }
    }
</script>
